// import logo from './logo.svg';
import './components/stylesheets/common.css'
import A1 from './components/A1';


function App() {
  return (
    <div className="App">
      <header className="App-header">

        <A1/>

      </header>
    </div>
  );
}

export default App;
